import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Phone } from "lucide-react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed w-full top-0 z-50 transition-all duration-300 ${scrolled ? "bg-white shadow-lg" : "bg-white"}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            {/* Replace with your logo */}
            <img
              src="/IK.png"
              alt="Logo"
              className="h-10 sm:h-14 lg:h-16 w-auto"
            />
          </div>

          <div className="hidden md:flex space-x-8">
            <a
              href="#home"
              className="font-bold text-gray-700 hover:text-orange-500 transition-colors"
            >
              Home
            </a>
            <a
              href="#about"
              className="font-bold text-gray-700 hover:text-orange-500 transition-colors"
            >
              About Us
            </a>
            <a
              href="#services"
              className="font-bold text-gray-700 hover:text-orange-500 transition-colors"
            >
              Services
            </a>
            <a
              href="#portfolio"
              className="font-bold text-gray-700 hover:text-orange-500 transition-colors"
            >
              Portfolio
            </a>
          </div>

          <div className="hidden md:block">
            <a href="#contact">
              <button className="bg-orange-500 text-white font-bold px-6 py-2 rounded-full hover:bg-orange-600 transition-colors flex items-center space-x-2">
                <Phone size={20} /> {/* icon size */}
                <span>Contact Us</span>
              </button>
            </a>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-4 pt-2 pb-4 space-y-2">
            <a
              href="#home"
              className="block py-2 text-gray-700 hover:text-orange-500"
            >
              Home
            </a>
            <a
              href="#about"
              className="block py-2 text-gray-700 hover:text-orange-500"
            >
              About Us
            </a>
            <a
              href="#services"
              className="block py-2 text-gray-700 hover:text-orange-500"
            >
              Services
            </a>
            <a
              href="#portfolio"
              className="block py-2 text-gray-700 hover:text-orange-500"
            >
              Portfolio
            </a>
            <a href="#contact" className="block w-full">
              <button className="w-full bg-orange-500 text-white px-6 py-2 rounded-full hover:bg-orange-600 mt-2">
                Contact Us
              </button>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
